import { Form } from 'antd'
import Button from 'components/Button/index'
import InfoCards from 'components/InfoCards'
import PlusIcon from 'components/icons/PlusIcon'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import AddCourseDrawer from 'modules/Courses/Partials/AddCourseDrawer'
import CoursesInfoTable from 'modules/Courses/Partials/CoursesTable'
import StudentsBulkUpload from 'modules/Courses/Partials/StudentsBulkUpload'
import {
  CardRow,
  SectionWrapper,
  TopHeader,
  TopHeading,
  TopRightFlex,
} from 'modules/Courses/Style/style'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { COLORS } from 'theme'
import { permittedEventCruds } from '../../utils/permissionsValidation'
const Courses = ({
  getCoursesList,
  degreeList,
  AddCourses,
  getSkillList,
  getDegreeData,
  degreeFilterList,
  DeleteCourses,
  EditCourses,
  ActiveIsCourses,
  DeleteSpecialization,
  AddMultiCourses,
  checkListCount,
  permissions,
  skillListData,
}) => {
  const [page, setPage] = useState(0)
  const object = useRef()
  const [addCourse, setAddCourse] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [degreeStreamMapId, setDegreeStreamMapId] = useState('')
  const [specialisationId, setSpecialisationId] = useState('')
  const [courseId, setCourseId] = useState('')
  const [createEditForm] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [degreeFilter, setDegreeFilter] = useState([])
  const [duration, setDuration] = useState([])
  const [examType, setExamType] = useState([])
  const [skillList, setSkillList] = useState([])
  const [statusFilter, setStatusFilter] = useState([])
  const [queryParam, setQueryParam] = useState({})
  const [cardsData, setCardsData] = useState([])
  const [listOfStudentSkills, setListOfStudentSkills] = useState([])
  const [uploadDrawer, setUploadDrawer] = useState(false)
  const [sort, setSort] = useState('')
  const [editCourse, setEditCourse] = useState(false)
  const [isEditable, setIsEditable] = useState(false)
  const [degreeId, setDegreeId] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  const [skillSearch, setSkillSearch] = useState('')
  const [domainFilter, setDomainFilter] = useState([])
  const [specializationFilter, setSpecializationFilter] = useState([])

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }
  useEffect(() => {
    skillsAPI(0)
  }, [])

  // The Degree & Department filter tree is built from every course, not from
  // the first page of them. Without getAllCourses the tree only listed the
  // degrees/departments/specialisations of the first 100 courses, so the rest
  // were impossible to filter on.
  useEffect(() => {
    getDegreeData('getAllCourses=true')
  }, [])
  const skillsAPI = async (pages, search) => {
    const { data } = await getSkillList('', search)
    if (data?.data?.result) {
      setListOfStudentSkills(data?.data?.result)
    }
  }
  const delayToFetchSkill = useCallback(
    debounce(data => {
      setSkillSearch(data)
    }, 500),
    []
  )
  useEffect(() => {
    skillsAPI(0, skillSearch)
  }, [skillSearch])
  useEffect(() => {
    getCoursesList({
      page,
      search,
      duration,
      examType,
      degreeFilter,
      skillList,
      statusFilter,
      sort,
      orderBy,
      setLoading,
      domainFilter,
      specializationFilter,
    })
  }, [
    page,
    search,
    duration,
    examType,
    degreeFilter,
    skillList,
    statusFilter,
    sort,
    orderBy,
    editCourse,
    domainFilter,
    specializationFilter,
  ])

  useEffect(() => {
    const cardData = [
      {
        key: 1,
        icon: <UserDefaultIcon />,
        text: 'No of degree',
        value: degreeList?.degreeCount,
        isSelected: false,
      },
      {
        key: 2,
        icon: <UserDefaultIcon />,
        text: 'No of Department',
        value: degreeList?.departmentCount,
        isSelected: false,
      },
      {
        key: 3,
        icon: <UserDefaultIcon />,
        text: 'Active Department',
        value: degreeList?.activeCourse,
        filter: '1',
        isSelected: false,
      },
      {
        key: 4,
        icon: <UserDefaultIcon />,
        text: 'Inactive Department',
        value: degreeList?.inActiveCourse,
        filter: '0',
        isSelected: false,
      },
    ]
    setCardsData(cardData)
  }, [degreeList])
  const onEdit = param => {
    setQueryParam(param)
    setCourseId(param?.id)
    setDegreeStreamMapId(param?.degreeStreamMapId)
    setSpecialisationId(param?.courseSpecialisationMap[0]?.specialisation?.id)
    createEditForm.setFieldsValue({
      type: param?.degreeStreamMap?.degree?.type,
      duration: param?.degreeStreamMap?.duration,
      degreeName: param?.degreeStreamMap?.degree?.name,
      domainName: param?.degreeStreamMap?.degree?.domain?.name,
      suffix: param?.degreeStreamMap?.degree?.shortForm,
      departmentName: param?.degreeStreamMap?.stream?.name,
      examtype: param?.degreeStreamMap?.examType,
      skills: param?.ancillaryMainSkills,
      specialisation: param?.courseSpecialisationMap?.map(item =>
        item?.specialisation?.name?.toUpperCase()
      ),
    })
    setDegreeId(param?.degreeStreamMap?.degree?.id)
    setIsEditing(true)
    setAddCourse(true)
  }
  const onDelete = async param => {
    await DeleteCourses(param?.id, setLoading)

    getCoursesList({
      page,
      search,
      duration,
      examType,
      degreeFilter,
      skillList,
      statusFilter,
      sort,
      orderBy,
      setLoading,
    })

    getDegreeData('getAllCourses=true')
  }
  const onActivate = async param => {
    const data = param?.status === 1 ? 0 : 1
    let payload = {
      status: data,
    }
    await ActiveIsCourses(param?.id, payload)

    getCoursesList({
      page,
      search,
      duration,
      examType,
      degreeFilter,
      skillList,
      statusFilter,
      sort,
      orderBy,
      setLoading,
    })
  }

  const AddNewCourse = () => {
    setDegreeStreamMapId('')
    setIsEditable(false)
    createEditForm.setFieldsValue({
      type: '',
      duration: 0,
      degreeName: '',
      suffix: '',
      departmentName: '',
      examtype: '',
      domainName: '',
      skills: [],
    })
    setIsEditing(false)
    setAddCourse(true)
  }
  const submitClose = () => {
    setSearch('')
    getCoursesList({
      page,
      search: '',
      duration,
      examType,
      degreeFilter,
      skillList,
      statusFilter,
      sort,
      orderBy,
      setLoading,
    })
    setAddCourse(false)
    setIsEditing(false)
  }

  const onPageChange = key => {
    object.current.scrollIntoView({ behavior: 'smooth' })
    setPage(key - 1)
  }

  const applyCardFilter = query => {
    let cardsCopy = [...cardsData]
    cardsCopy = cardsCopy.map(val => {
      if (query.filter === val.filter) {
        if (val.isSelected) {
          val.isSelected = false
        } else {
          setStatusFilter(query.filter)
        }
      } else {
        val.isSelected = false
      }
      return val
    })
    setCardsData(cardsCopy)
    setPage(0)
  }

  const cruds = permittedEventCruds(permissions, 'Courses')?.map(permission =>
    permission?.events?.eventName?.toUpperCase()
  )

  return (
    <>
      <SectionWrapper column>
        <div ref={object}></div>

        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Courses</TopHeading>
          {cruds?.includes('NEW COURSES') && (
            <TopRightFlex>
              <Button.Primary
                height={'38px'}
                text={'New Courses'}
                icon={<PlusIcon />}
                onClick={AddNewCourse}
              />
            </TopRightFlex>
          )}
        </TopHeader>
        <CardRow spaceBetween>
          {cardsData?.map(card => (
            <InfoCards
              key={card?.text}
              padding={'20px'}
              width={'25%'}
              icon={card?.icon}
              text={card?.text}
              value={card?.value}
              background={
                card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95
              }
              isSelected={card?.isSelected}
              onClick={() => {
                applyCardFilter(card)
              }}
            />
          ))}
        </CardRow>
        <CoursesInfoTable
          skillListData={skillListData}
          getSkillList={getSkillList}
          degreeList={degreeList}
          degreeFilterList={degreeFilterList}
          onEdit={onEdit}
          onDelete={onDelete}
          onActivate={onActivate}
          loading={loading}
          page={page + 1}
          onPageChange={onPageChange}
          search={search}
          setSearch={setSearch}
          duration={duration}
          setDuration={setDuration}
          setExamType={setExamType}
          setDegreeFilter={setDegreeFilter}
          setSkillList={setSkillList}
          setStatusFilter={setStatusFilter}
          listOfStudentSkills={listOfStudentSkills}
          setPage={setPage}
          setSort={setSort}
          setOrderBy={setOrderBy}
          orderBy={orderBy}
          sortBy={sort}
          cruds={cruds}
          setIsEditable={setIsEditable}
          domainFilter={domainFilter}
          setDomainFilter={setDomainFilter}
          setSpecializationFilter={setSpecializationFilter}
        />
      </SectionWrapper>
      {addCourse && (
        <AddCourseDrawer
          createEditForm={createEditForm}
          addCourse={addCourse}
          setAddCourse={setAddCourse}
          isEditing={isEditing}
          degreeStreamMapId={degreeStreamMapId}
          specialisationId={specialisationId}
          setDegreeStreamMapId={setDegreeStreamMapId}
          setSpecialisationId={setSpecialisationId}
          AddMultiCourses={AddMultiCourses}
          getSkillList={getSkillList}
          courseId={courseId}
          setPage={setPage}
          EditCourses={EditCourses}
          submitClose={submitClose}
          listOfStudentSkills={listOfStudentSkills}
          DeleteSpecialization={DeleteSpecialization}
          queryParam={queryParam}
          cruds={cruds}
          getCoursesList={getCoursesList}
          setEditCourse={setEditCourse}
          editCourse={editCourse}
          isEditable={isEditable}
          degreeId={degreeId}
          delayToFetchSkill={delayToFetchSkill}
          getFilterDegreeData={getDegreeData}
        />
      )}
      <StudentsBulkUpload
        uploadDrawer={uploadDrawer}
        setUploadDrawer={setUploadDrawer}
        getFilterDegreeData={getDegreeData}
      />
    </>
  )
}
export default Courses
